import styled from 'styled-components';

export const Container = styled.div<ResultImageContainerProps>`
    height: 85px;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition: opacity 0.2s;
    width: 120px;
`;

export const Image = styled.img`
    max-width: 100%;
    width: 100%;
`;
